import AnimationService from "@/shared/services/animation-service";
import INavigationItem from "@/apps/NavigationWidget/model/navigation-item";
import {Breakpoint} from "@/shared/models/breakpoint-type";
import store from "@/apps/NavigationWidget/store/store";


export default class NavigationWidgetAnimationService {
    public static closeMenu(): void {
        if (!store.state.loading) {
            store.commit('setMenuOpen', false);
            store.commit('removeBodyEleClass', 'vuw-overflow-y-hide');
        }
    }

    public static changePlusToMinus(icon: HTMLElement): void {
        icon.classList.remove("fa-plus");
        icon.classList.add("fa-minus");
    }

    public static openMenu(): void {
        store.commit('setLoading', true);

        setTimeout(() => {
            store.commit('setLoading', false);
        }, 200);

        store.commit('setMenuOpen', true);
        store.commit('addBodyEleClass', 'vuw-overflow-y-hide');

        setTimeout(() => {
            AnimationService.rotate('.fa-times', false);
            let element = document.getElementsByClassName('nav-second')[0] as HTMLElement;
            if (element) {
                this.changeOpacity0('nav-second');
                this.changeOpacity0('breadcrumb-last');
            }

            let icon = document.getElementsByClassName("plus-minus-icon")[0] as HTMLElement;
            if (icon) {
                this.changePlusToMinus(icon);
            }
        }, 0);
    }

    public static selectMenuItem(item: INavigationItem, reset: boolean): void {
        if (reset && store.state.storedTree.length > 0) {
            store.commit('popStoredTreeItem')
        }

        store.commit('pushStoredTreeItem', item);
    }

    public static selectMenuItemByOther(item: INavigationItem): void {
        store.commit('setStoredTree', store.state.storedTree.slice(0, store.state.storedTree.indexOf(item) + 1))
    }

    public static resetToFirstLevel(): void {
        store.commit('setStoredTree', [])
    }

    public static openDefaultMenuItems(data: Array<INavigationItem>) {
        data.forEach(item => {
            if (item.active && item.subItems.length) {
                this.selectMenuItem(item, false);
                this.openDefaultMenuItems(item.subItems);
            }
        })
    }

    public static init(json: any): void {
        store.commit('setData', json)

        try {
            this.openDefaultMenuItems(store.state.data.subItems);
        } catch (error) {
            console.error("No subitems were found for the menu");
        }
    }


    /**
     * navFirstTransitions: Controls the transitions for when the first navigation panel is clicked
     * @param item  INavigationItem: the parameter used for the selectMenuItem function
     */
    public static navFirstTransitions(item: INavigationItem): void {
        if (store.state.currentBreakpoint !== Breakpoint.Mobile) { // first part is the same for desktop and tablet width
            this.selectMenuItem(item, true); // change active menu item

            setTimeout(() => {
                AnimationService.rotate(".plus-minus-icon", false);
                this.changeOpacity0('nav-second', false);
                this.changeOpacity0('breadcrumb-last', false);
            }, 0);

            setTimeout(() => {
                if (store.state.currentBreakpoint === Breakpoint.Desktop || store.state.currentBreakpoint === Breakpoint.TabletLandscape) {  // desktop specific
                    AnimationService.fade('vuw-transition-opacity', '.nav-second');
                    AnimationService.fade('vuw-transition-opacity', '.breadcrumb-last');

                } else if (store.state.currentBreakpoint === Breakpoint.TabletPortrait) { // tablet portrait specific
                    this.transitionRegulator('nav-second', 'vuw-slide-to-right', 400, 800);
                    AnimationService.fade('vuw-transition-opacity', '.breadcrumb-last');
                }
            }, 0);
            this.calculateX();

        } else {    // mobile
            this.slide('nav-first', 'vuw-transform-left');
            setTimeout(() => {
                this.selectMenuItem(item, false);
                setTimeout(() => {
                    this.changeOpacity0('nav-second');
                    this.slideInMobile('nav-second', 'vuw-transform-right');
                    AnimationService.fade('vuw-transition-opacity', '.breadcrumb-last');
                }, 50);
            }, 400);
        }
    }

    /**
     * navSecondTransitions: Controls the transitions for when the second navigation panel is clicked
     * @param item  INavigationItem: the parameter used for the selectMenuItem function
     */
    public static navSecondTransitions(item: INavigationItem): void {
        if (store.state.currentBreakpoint !== Breakpoint.Mobile) { // dektop and tablet portrait
            this.selectMenuItem(item, false);
            this.slideNavFirst();
            this.transitionRegulator('nav-second', 'vuw-slide', 500, 1000);
            setTimeout(() => {
                AnimationService.rotate(".plus-minus-icon", false);
                AnimationService.fade('vuw-transition-opacity', '.breadcrumb-last');
                this.calculateX();
            }, 0);

        } else {    // mobile
            this.slide('nav-second', 'vuw-transform-left');
            setTimeout(() => {
                this.selectMenuItem(item, false);
                setTimeout(() => {
                    this.changeOpacity0('nav-second', false);
                }, 0);
            }, 400);
            setTimeout(() => {
                this.slideInMobile('nav-second', 'vuw-transform-right');
                this.changeOpacity0('nav-second');
                AnimationService.fade('vuw-transition-opacity', '.breadcrumb-last');
            }, 500);
        }
    }

    /**
     * GoBackToTransistions: Takes user back to a previous menu level via the breadcrumb or go-back-to option, this function also controls all the corresponding transitions
     * @param item  INavigationItem: the parameter used for the selectMenuItemByOther function
     */
    public static goBackToTransitions(item: INavigationItem): void {
        if (store.state.currentBreakpoint === Breakpoint.Desktop || store.state.currentBreakpoint === Breakpoint.TabletLandscape) { //  desktop
            let element = document.getElementsByClassName('nav-first')[0] as HTMLElement;
            element.classList.add('vuw-opacity-1');
            AnimationService.fade('vuw-transition-opacity', '.nav-first', false);
            AnimationService.fade('vuw-transition-opacity', '.nav-second', false);
            AnimationService.fade('vuw-transition-opacity', '.breadcrumb-last', false);
            setTimeout(() => {
                this.selectMenuItemByOther(item);
                setTimeout(() => {
                    this.changeOpacity0('breadcrumb-last');
                    AnimationService.rotate(".plus-minus-icon",);
                }, 0);
                this.transitionRegulator('nav-first', 'vuw-slide', 100, 800);
                this.transitionRegulator('nav-second', 'vuw-slide', 500, 1000);
                this.setTimeOutCalculate();
            }, 400);

        } else if (store.state.currentBreakpoint === Breakpoint.TabletPortrait) { //  tablet portrait
            this.changeOpacity0('nav-second', false);
            this.changeOpacity0('nav-first', false);
            this.selectMenuItemByOther(item);
            setTimeout(() => {
                AnimationService.rotate(".plus-minus-icon",);
                this.transitionRegulator('nav-first', 'vuw-slide-to-right', 400, 800);
                setTimeout(() => {
                    this.changeOpacity0('nav-second');
                    this.changeOpacity0('breadcrumb-last');
                    this.transitionRegulator('nav-second', 'vuw-slide-to-right', 400, 800);
                }, 400);
                this.setTimeOutCalculate();
            }, 0);

        } else { //  Mobile
            this.slide('nav-second', 'vuw-transform-right');
            AnimationService.fade('vuw-transition-opacity', '.breadcrumb-last', false);
            setTimeout(() => {
                this.selectMenuItemByOther(item);
                setTimeout(() => {
                    this.changeOpacity0('nav-second', false);
                    this.changeOpacity0('nav-first', false);
                    this.changeOpacity0('breadcrumb-last');
                }, 0);
                setTimeout(() => {
                    this.changeOpacity0('nav-second');
                    this.changeOpacity0('nav-first');
                    this.slideInMobile('nav-second', 'vuw-transform-left');
                }, 200);
            }, 490);
        }
    }

    /**
     * backToHomeTransitions: Controls the transitions for when the home icon is clicked
     */
    public static backToHomeTransitions(): void {
        if (store.state.currentBreakpoint !== Breakpoint.Mobile) {
            this.slide('nav-first', 'vuw-start');
            this.slide('nav-second', 'vuw-start');

            setTimeout(() => {
                this.resetToFirstLevel();
            }, 250);

        } else {    // mobile
            this.slide('nav-second', 'vuw-transform-right');
            AnimationService.fade('vuw-transition-opacity', '.breadcrumb-last', false);

            setTimeout(() => {
                this.resetToFirstLevel();
            }, 500);
        }
    }

    /**
     * transitionRegulator: Many transitions can be carried out using this format.
     * @param elementClass  string: Class of element to be transitioned
     * @param transition    string: The transition class
     * @param timeout1      number: timeout for first timeout function
     * @param timeout2      number: timeout for second timeout function
     */
    public static transitionRegulator(elementClass: string, transition: string, timeout1: number, timeout2: number): void {
        let element = document.getElementsByClassName(elementClass)[0] as HTMLElement;
        element.classList.add('vuw-opacity-0');

        setTimeout(() => {
            element.classList.add('vuw-start', transition);
        }, 0);

        setTimeout(() => {
            element.classList.remove('vuw-opacity-0', 'vuw-start');
            element.classList.add('vuw-end');
        }, timeout1);

        setTimeout(() => {
            element.classList.remove(transition, 'vuw-end');
        }, timeout2);
    }


    /**
     * calculateX: Caculates the position from where nav-first should slide in
     */
    public static calculateX(): void {
        let navFirst = document.getElementsByClassName('nav-first')[0] as HTMLElement;
        let width = navFirst.clientWidth;
        let padding = parseFloat(window.getComputedStyle(navFirst).getPropertyValue('padding-right'));
        store.state.leftSideNavSecond = width + padding - 100;
    }

    /**
     * slideNavFirst: slides the navFirst html element, from the LeftSideNavSecond point
     */
    public static slideNavFirst(): void {
        let item = document.getElementsByClassName('nav-first')[0] as HTMLElement;
        item.style.transform = 'translateX(' + store.state.leftSideNavSecond.toString() + 'px)';

        setTimeout(() => {
            item.style.transition = 'transform 850ms ease-out';
            item.style.transform = 'translateX(0)';
        }, 10);

        setTimeout(() => {
            item.style.transform = '';
            item.style.transition = '';
        }, 1000);
    }

    /**
     * setTimeOutCalculate: sets timeout on calculateX
     */
    public static setTimeOutCalculate(): void {
        setTimeout(() => {
            this.calculateX();
        }, 50);
    }


    /**
     * slide: slides element
     * @param item      string: Class of element to be slided
     * @param className string: Class indicating the position to slide to
     */
    public static slide(item: string, className: string): void {
        let element = document.getElementsByClassName(item)[0] as HTMLElement;
        element.classList.add('vuw-slide', className);

        setTimeout(() => {
            element.classList.remove('vuw-slide', className);
        }, 500);
    }


    /**
     * SlideInMobile: slides in htmlelements in the mobile screenwitdh
     * @param item        string: class of element to add class to
     * @param classname   string: class to be added/removed from element to be slided in
     */
    public static slideInMobile(item: string, classname: string): void {
        let element = document.getElementsByClassName(item)[0] as HTMLElement;
        if (element) {
            element.classList.add(classname);
            setTimeout(() => {
                element.classList.add('vuw-slide');
            }, 0);

            setTimeout(() => {
                element.classList.add('vuw-end');
            }, 400);

            setTimeout(() => {
                element.classList.remove(classname, 'vuw-slide', 'vuw-end');
            }, 1000);
        }
    }

    /**
     * changeOpacity0: removes or adds an opacity class
     * @param item      string: class of element to add class to
     * @param remove    boolean: determines if class is added or removed
     */
    public static changeOpacity0(item: string, remove: boolean = true): void {
        let element = document.getElementsByClassName(item)[0] as HTMLElement;

        if (element) {
            if (remove) {
                element.classList.remove('vuw-opacity-0');
            } else {
                element.classList.add('vuw-opacity-0');
            }
        }
    }
}
